import React from "react";
import { TableRow, withStyles } from "@material-ui/core";
import {
  get,
  size,
  map,
  isEmpty,
  sortBy,
  sum,
  includes,
  filter,
  concat,
} from "lodash";
import clsx from "clsx";

import TableCellStyled from "../../Common/TableCellStyled";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  cell: {
    height: "40px",
    padding: "0px 8px !important",
  },
  spanCell: {
    verticalAlign: "top",
    paddingTop: "11px !important",
    borderBottom: `1px solid ${colors.darkGrey}`,
  },
  link: {
    color: colors.primary,
    width: "30px",
    height: "30px",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
};

const OnsiteCountsDetailsRow = withStyles(styles)((props) => {
  const {
    classes,
    data,
    index,
    isLast = false,
    openDialog,
    defaultExpand = false,
    expandedSites,
    setExpandedSites,
  } = props;
  const [open, setOpen] = React.useState(defaultExpand);

  const expand = () => {
    setOpen(!open);

    if (includes(expandedSites, data.id)) {
      setExpandedSites(filter(expandedSites, (s) => s !== data.site_id));
    } else {
      setExpandedSites(concat(expandedSites, [data.site_id]));
    }
  };

  return (
    <>
      <TableRow
        style={{
          cursor: !isEmpty(get(data, ["zones"])) ? "pointer" : "",
          backgroundColor:
            index % 2 === 0 || !isEmpty(get(data, ["zones"]))
              ? colors.white
              : colors.lightGrey,
          borderBottom:
            (!isEmpty(get(data, ["zones"])) && !open) || isLast
              ? `1px solid ${colors.darkGrey}`
              : "none",
        }}
        onClick={() => {
          if (!isEmpty(get(data, ["zones"]))) {
            expand();
          }
        }}
      >
        {!isEmpty(get(data, ["zones"])) ? (
          <>
            <TableCellStyled
              className={clsx(classes.cell, {
                [classes.spanCell]: open,
              })}
              rowSpan={open ? size(get(data, ["zones"])) + 1 : null}
            >
              <span
                style={{
                  width: "20px",
                  display: "inline-block",
                }}
              >
                <img
                  src={open ? images.arrowOpenBlack : images.arrowClosedBlack}
                  alt="arrow"
                  width={open ? "10px" : "8px"}
                />
              </span>
              <span
              // className={classes.link}
              // onClick={() =>
              //   openDialog({
              //     profile_type_ids: [],
              //     site_ids: [get(data, ["site_id"])],
              //     zone_ids: [],
              //   })
              // }
              >
                {get(data, ["site_name"])}
              </span>
            </TableCellStyled>
            <TableCellStyled className={classes.cell} />
          </>
        ) : (
          <>
            <TableCellStyled className={classes.cell}>
              <span
              // className={classes.link}
              // onClick={() =>
              //   openDialog({
              //     profile_type_ids: [],
              //     site_ids: [get(data, ["site_id"])],
              //     zone_ids: [get(data, ["zone_id"])],
              //   })
              // }
              >
                {get(data, ["zone_name"])}
              </span>
            </TableCellStyled>
          </>
        )}
        {map(
          sortBy(get(data, ["profile_types"]), (t) => t.profile_type_id),
          (type, i) => (
            <TableCellStyled
              key={i}
              className={classes.cell}
              style={{
                borderLeft: i === 0 ? `1px solid ${colors.black23}` : "none",
              }}
            >
              <span
                className={classes.link}
                onClick={(e) => {
                  e.stopPropagation();
                  openDialog({
                    profile_type_ids: [type.profile_type_id],
                    site_ids: [get(data, ["site_id"])],
                    zone_ids: get(data, ["zone_id"])
                      ? [get(data, ["zone_id"])]
                      : [],
                  });
                }}
              >
                {get(type, ["profile_count"]) || "0"}
              </span>
            </TableCellStyled>
          )
        )}
        <TableCellStyled className={classes.cell}>
          <span
            className={clsx(classes.link, "text-italic", "bold-500")}
            onClick={(e) => {
              e.stopPropagation();
              openDialog({
                profile_type_ids: [],
                site_ids: [get(data, ["site_id"])],
                zone_ids: !isEmpty(get(data, ["zones"]))
                  ? []
                  : [get(data, ["zone_id"])],
              });
            }}
          >
            {sum(
              map(get(data, ["profile_types"]), (type) =>
                get(type, ["profile_count"])
              )
            )}
          </span>
        </TableCellStyled>
      </TableRow>
      {open &&
        !isEmpty(get(data, ["zones"])) &&
        map(get(data, ["zones"]), (z, i) => (
          <OnsiteCountsDetailsRow
            key={i}
            data={z}
            index={i + 1}
            isLast={i + 1 === size(get(data, ["zones"]))}
            openDialog={openDialog}
          />
        ))}
    </>
  );
});

export default OnsiteCountsDetailsRow;
